(function () {
  'use strict';

  /* Barra de anuncios rotativa */
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, 4000);
  });

  /* Botones que llevan al bloque de compra */
  document.querySelectorAll('[data-scroll-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector('[data-product-section] .bundles, [data-product-section] .pdp__info');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-product-section]').forEach(initProduct);

  function initProduct(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = root.querySelector('form.pdp__form');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var btn = root.querySelector('[data-add-btn]');
    var btnText = root.querySelector('[data-add-text]');
    var btnPrice = root.querySelector('[data-btn-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var colorLabel = root.querySelector('[data-color-label]');

    function selectedOptions() {
      var opts = [];
      root.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        var checked = fs.querySelector('input:checked');
        if (checked) opts[idx] = checked.value;
      });
      return opts;
    }

    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      if (!v) {
        btn.disabled = true;
        btnText.textContent = 'No disponible';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price_fmt;
      var pctEl = root.querySelector('[data-pct]:not(label)');
      var card = root.querySelector('.bundle input:checked');
      card = card ? card.closest('.bundle') : null;
      var anchor = card ? card.getAttribute('data-anchor') : '';
      var pct = card ? card.getAttribute('data-pct') : '';
      if (anchor) { compareEl.textContent = anchor; compareEl.hidden = false; }
      else if (v.compare > v.price) { compareEl.textContent = v.compare_fmt; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
      if (pctEl) { pctEl.textContent = pct; pctEl.hidden = !pct; }
      btn.disabled = !v.available;
      btnText.textContent = v.available ? data.cta : 'Agotado';
      if (btnPrice) btnPrice.textContent = '· ' + v.price_fmt;
      if (stickyPrice) stickyPrice.textContent = v.price_fmt;
      if (colorLabel) {
        var cf = colorLabel.closest('fieldset');
        var c = cf && cf.querySelector('input:checked');
        if (c) colorLabel.textContent = c.value;
      }
      if (window.history && window.history.replaceState && root.closest('.template-product')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.media) goToMedia(v.media);
    }

    root.querySelectorAll('[data-option]').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();

    /* Galería */
    var main = root.querySelector('[data-gallery-main]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots = root.querySelectorAll('.gallery__dot');
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function goTo(i) {
      if (!main) return;
      main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }
    function goToMedia(id) {
      var slides = root.querySelectorAll('.gallery__slide');
      slides.forEach(function (s, i) { if (String(s.getAttribute('data-media-id')) === String(id)) goTo(i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    if (main) {
      var to;
      main.addEventListener('scroll', function () {
        clearTimeout(to);
        to = setTimeout(function () { setActive(Math.round(main.scrollLeft / main.clientWidth)); }, 60);
      });
    }

    /* Fecha estimada de entrega (días hábiles) */
    var del = root.querySelector('[data-delivery]');
    if (del) {
      var addBusiness = function (d, n) {
        var r = new Date(d);
        while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
        return r;
      };
      var fmt = function (d) { return d.toLocaleDateString('es-ES', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var now = new Date();
      del.querySelector('[data-d1]').textContent = fmt(addBusiness(now, parseInt(del.dataset.min, 10)));
      del.querySelector('[data-d2]').textContent = fmt(addBusiness(now, parseInt(del.dataset.max, 10)));
    }

    /* Barra fija en móvil */
    var sticky = root.querySelector('[data-sticky-atc]');
    if (sticky && btn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = e.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', !e.isIntersecting && below);
        });
      });
      io.observe(btn);
      root.querySelector('[data-sticky-btn]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(btn); else btn.click();
      });
    }
  }
})();
